import axios, { isAxiosError } from "axios";

import { AccessTokenSingleton } from "#modules/auth/domain/AccessTokenSingleton";
import { isUserDisabledError } from "#modules/auth/domain/isUserDisabledError";
import { handleDisabledUser } from "#modules/auth/infra/handleDisabledUser";
import { camelize } from "#shared/helpers/ApiHelper";

export const fetcher = axios.create({
  baseURL: import.meta.env.VITE_BASE_API_URL,
  timeout: 10000,
  headers: {
    "Content-Type": "application/json",
  },
});

fetcher.interceptors.request.use((config) => {
  const accessToken = AccessTokenSingleton.getInstance().getAccessToken();

  if (accessToken) {
    config.headers.Authorization = `Bearer ${accessToken}`;
  }

  return config;
});

fetcher.interceptors.response.use(
  (config) => {
    // Skip camelization for binary responses (blob, arraybuffer)
    if (config.config.responseType === "blob" || config.config.responseType === "arraybuffer") {
      return config;
    }

    config.data = camelize(config.data);

    return config;
  },
  (error: unknown) => {
    if (isAxiosError(error) && error.response) {
      if (isUserDisabledError(error.response.status, error.response.data)) {
        void handleDisabledUser();
      }
    }

    return Promise.reject(error);
  },
);
